import React from 'react';

import { Skeleton } from '@mui/material';

import Button from '../../../../../components/Button';
import ContentCard from '../../../../../components/ContentCard';
import { Student } from '../../../../../services/students/types';

interface AnalyticsCardProps {
  student?: Student,
}

const AnalyticsCard = ({ student } : AnalyticsCardProps) => {
  if (!student) {
    return (
      <Skeleton variant="rectangular" height={128} />
    );
  }

  return (
    <ContentCard variant="outlined" title="Analytics">
      <Button href={`/analytics/${student.id}`}>
        View Analytics
      </Button>
    </ContentCard>
  );
};

export default AnalyticsCard;
